import Cookies from 'js-cookie';

const secureCookieOptions = {
  secure: true,
  sameSite: 'Strict',
};

export function setCookie(name, value) {
  if (typeof document !== 'undefined') {
    Cookies.set(name, value, secureCookieOptions);
  }
}

export function getCookie(name) {
  if (typeof document !== 'undefined') {
    return Cookies.get(name);
  }
}

export function removeCookie(name) {
  if (typeof document !== 'undefined') {
    Cookies.remove(name, secureCookieOptions);
  }
}

